<template>
  <el-dialog title="添加部门管理员" :visible.sync="dialogVisible" width="50%" :before-close="handleClose" custom-class="dialogPaddingTop0">
    <el-container>
        <el-main class="paddingLeft0">
         
              <el-form  :model="formList" size="mini" class="demo-form-inline"  label-width="150px" :rules="rules" ref="ruleForm">

                <el-row>                   
                    <el-col :span="24">
                      <el-form-item label="选择用户:" prop="userId">
                        <el-select v-model="formList.userId" placeholder="请选择或搜索用户姓名" style="width:100%"  filterable remote :remote-method="remoteMethod" :loading="loading" clearable>
                            <el-option  v-for="item in useroptions" :key="item.id" :label="item.name" :value="item.id"></el-option>                            
                        </el-select>
                      </el-form-item>
                 </el-col>
                </el-row>

                <el-row>                   
                    <el-col :span="24">
                      <el-form-item label="可管理部门:" prop="departid">                      
                          <department_tree @checkAll="checkAll"  :invalid="invalid"/>
                      </el-form-item>
                 </el-col>
                </el-row>

              </el-form>  

        </el-main>
    </el-container>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onCancel" size="small">{{$t('cancel')}}</el-button>
      <el-button type="primary" @click="onOk" size="small">{{$t('confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import department_tree from "@/components/department_tree.vue";
export default {
  props: ["visible"],
  data() {
    return {
      invalid:true,//为true表示有复选框
      checkedAll:null,//所有选中的数据
      loading:false,
      searchdata: {
        domainid: this.$route.query.domainid,
        superiorname: "",
        departmentid: "",
        loginno: "",
        roleid: "",
        superiorid:"",
        currpage: 1,
        pagelines: 50,
        orderby: "",
        data:{
          name: "",
        }
      },
      formList:{
        userId:"",
        departid:[]
      },//表单
      useroptions:[],//用户下拉列表
      Departoptions:[],//可管理部门列表
      rules: {  
        userId: [{ required: true, message: "请选择用户", trigger: "blur" }],
        departid: [{ required: true, message: "请选择部门", trigger: "blur" }],
      }
    };
  },
  components:{
    department_tree
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  created() {
    this.searchTableData();    
  },
  methods: {
    checkAll(all){
      this.checkedAll=all;
    },
    resetSearchTableData(){
      this.searchdata.data.name='';
      this.searchTableData();
    },
    handleReserve(row){
      return row.id
    },
    onOk() {
       console.log(this.formList.userId)
      if(this.formList.userId==""){
        this.$message({
          showClose: true,
          message: "请选择用户",
          type: "error"
        });
        return
      } 
      if(this.checkedAll&&this.checkedAll.length){
        this.checkedAll.forEach(item=>{
          this.formList.departid.push(item.id)
        })
      }else{
        this.$message({
          showClose: true,
          message: "请选择部门",
          type: "error"
        });
        return
      }
     
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
            this.$api.addDomaindepartmentManagers(
              { domainid: this.$route.query.domainid,userId:this.formList.userId,data: this.formList.departid },
              {
                onSucess: resp => {
                  if (resp.data.errcode == 0) {
                    this.$message({
                      showClose: true,
                      message: this.$t('msg_add_success'),
                      type: "success"
                    });    
                    this.checkedAll=[]
                    this.$emit("select-ok");   
                    this.dialogVisible = false;           
                  } else {
                    this.$message({
                      showClose: true,
                      message: resp.data.errmsg,
                      type: "error"
                    });
                  }
                }
              }
            );
        }
      });
      
    },
    onCancel() {
      this.dialogVisible = false;
    },
    handleSelectionChange(rows){
      this.multipleSelection = rows;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleSizeChange(size){
      this.searchdata.pagelines=size;
      this.searchTableData();
    },
    remoteMethod(query){//远程搜索
        // console.log(query+"输入值")
        if(query!=""){
          this.loading=true
          this.searchdata.data.name=query
          this.$api.getNotDepartUsers(this.searchdata, {
            onSucess: resp => {          
              if(resp.data.data.datas){  
                this.loading=false
                this.useroptions=resp.data.data.datas              
              }         
            }
          })
        }
    },
    searchTableData() {   
      //默认第一次查询50条用户
      this.$api.getNotDepartUsers(this.searchdata, {
        onSucess: resp => {          
          if(resp.data.data.datas){  
            this.loading=false
            this.useroptions=resp.data.data.datas              
          }         
        }
      }) 
    },
  }
};
</script>

<style lang="scss">
.deptTree .el-scrollbar .el-scrollbar__wrap{
  padding-bottom:15px;
}
</style>